export enum ENUM_SECTION_PROMO {
    MARKETPLACE = 'MARKETPLACE',
    SELLER = 'SELLER',
}